import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CompliancePredesDestinationImpcCodeNotRegisteredReport
  from '../components/CompliancePredesDestinationImpcCodeNotRegisteredReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CompliancePredesDestinationImpcCodeNotRegisteredDetailsSelectors';

export function CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer(props) {
  return (
    <CompliancePredesDestinationImpcCodeNotRegisteredReport
      reportId={ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};
export default connect(mapStateToProps)(CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer);
